import { FC } from "react";
import { createStyles, Link, makeStyles, Typography } from "@material-ui/core";
import { Error as ErrorIcon } from "@material-ui/icons";

import { CONTACT_US_FORM_URL } from "constants/index";
import theme from "theme";
import { linkPurpleStyles } from "theme/constants";

const useStyles = makeStyles(() =>
  createStyles({
    link: linkPurpleStyles,
  }),
);

const ErrorDisplay: FC = () => {
  const classes = useStyles();
  return (
    <>
      <ErrorIcon
        style={{
          color: theme.custom.palette.red.main,
          fontSize: "4rem",
          marginBottom: theme.spacing(1),
        }}
      />
      <Typography variant="h6" align="center" gutterBottom>
        Something went wrong
      </Typography>
      <Typography align="center">
        Please try again and{" "}
        <Link
          className={classes.link}
          href={CONTACT_US_FORM_URL}
          target="_blank"
          rel="noopener noreferrer"
        >
          contact us
        </Link>{" "}
        if the problem persists.
      </Typography>
    </>
  );
};

export default ErrorDisplay;
